var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1300 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #f3ecf1;\n      }\n\n      .cls-4 {\n        fill: #f2e2dc;\n      }\n\n      .cls-5 {\n        fill: #fbd5a2;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #e68f47;\n      }\n\n      .cls-8 {\n        fill: #ffaa64;\n      }\n\n      .cls-9 {\n        fill: #fbb766;\n      }\n\n      .cls-10 {\n        fill: #a19c9f;\n      }\n\n      .cls-11 {\n        fill: #d1763d;\n      }\n\n      .cls-12 {\n        fill: #cc715e;\n      }\n\n      .cls-13 {\n        fill: #d9d3d7;\n      }\n\n      .cls-14 {\n        fill: #29190f;\n      }\n\n      .cls-15 {\n        fill: #3a3e4a;\n      }\n\n      .cls-16 {\n        fill: #4c5061;\n      }\n\n      .cls-17 {\n        fill: #7b808a;\n      }\n\n      .cls-18 {\n        fill: url(#Unbenannter_Verlauf_108);\n      }\n\n      .cls-2 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient);\n        mix-blend-mode: screen;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_108",
    "data-name": "Unbenannter Verlauf 108",
    x1: 650,
    y1: 1345.39,
    x2: 650,
    y2: 177.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#807f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c99b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 654.72,
    y1: 44.45,
    x2: 654.72,
    y2: 423.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m1300,77.54v844.91c0,42.82-34.54,77.54-77.13,77.54H77.13c-42.6,0-77.13-34.72-77.13-77.54V77.54C0,34.72,34.54,0,77.13,0h1145.74c42.6,0,77.13,34.72,77.13,77.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m93.72,104.99h71.79c9.53,0,17.26-7.77,17.26-17.35h0c0-9.58-7.73-17.35-17.26-17.35h-71.79c-9.53,0-17.26,7.77-17.26,17.35h0c0,9.58,7.73,17.35,17.26,17.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1186.21,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1129.36,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1072.51,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m727.44,158.73v616.38c-48.49-4.65-96.95-3.03-145.44,1.86V160.6c48.49-4.89,96.95-6.52,145.44-1.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m900.52,982.81c0,4.82-.27,9.79-.83,14.8-.08.8-.19,1.59-.34,2.39h-25.37c.42-1.67.72-3.42.91-5.2.83-7.33.79-14.61.34-21.37-1.28-18.67-5.93-33.36-6.04-33.55v-.04c-.94-2.92-.75-5.96.3-8.62v-.04c.27-.61.53-1.14.87-1.71,1.47-2.47,3.85-4.44,6.8-5.43,4.53-1.48,9.25-.27,12.46,2.77,1.47,1.4,2.6,3.15,3.28,5.24.38,1.1,7.66,23.68,7.63,50.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m875.53,994.27c-.23,1.97-.53,3.87-.91,5.73h-25.71c.87-2.66,1.47-5.5,1.81-8.54.98-8.54.79-17.08.11-24.75-1.4-14.88-4.72-26.64-5.59-29.49-.15-.42-.23-.65-.23-.68-.26-.8-.41-1.63-.53-2.43-.26-2.16.08-4.29.87-6.19v-.04c.79-1.94,2.04-3.64,3.66-4.97.83-.68,1.74-1.25,2.76-1.71.38-.19.79-.34,1.21-.49.76-.23,1.51-.42,2.27-.53,2.79-.38,5.55.23,7.89,1.56,1.85,1.1,3.43,2.66,4.53,4.55.41.76.79,1.56,1.06,2.39.08.19.34,1.06.75,2.51v.04c.57,1.9,1.36,4.78,2.19,8.46,1.89,8.05,4,19.85,4.53,33.17.3,6.83.15,14.08-.68,21.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m851.4,990.93c-.34,3.15-.91,6.19-1.62,9.07h-26.16c1.4-3.61,2.45-7.59,2.94-11.88,2.08-18.41-1.13-36.67-3.51-46.8-1.17-5.01-2.11-8.05-2.15-8.12-2.15-6.57,1.4-13.66,7.97-15.83,6.53-2.16,13.55,1.4,15.74,7.97.08.19.34,1.06.76,2.54v.04c.19.61.38,1.29.6,2.09v.04c.26.95.53,2.05.87,3.26,1.93,7.82,4.53,20.69,5.17,35.49.34,7.06.23,14.54-.6,22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m769.22,641.88h0c32.91-7.24,65.43,13.7,72.63,46.79l59.88,210.85c2.22,7.82-2.07,16.01-9.74,18.6l-72.56,24.44c-7.81,2.63-16.27-1.5-19.05-9.3l-77.7-218.35c-7.21-33.08,13.63-65.78,46.54-73.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m885.31,953.66c0,.53-.04,1.1-.11,1.67l-.15,1.21-1.28,10.89-.38,3.3-3.44,29.26h-28.09l.98-8.24,2.19-18.64,2.49-21.1c.76-6.38,5.66-11.27,11.67-12.18.83-.15,1.66-.19,2.49-.15.45-.04.87,0,1.32.08,1.47.19,2.83.57,4.11,1.14,2.11.95,3.93,2.43,5.29,4.21,1.85,2.39,2.91,5.35,2.91,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m912.19,1000h-25.18c.15-.8.26-1.59.34-2.43,1.02-9.22.72-18.37-.11-26.49-.57-5.43-1.36-10.36-2.19-14.54-.98-5.09-2-9.07-2.64-11.42-.45-1.56-.72-2.43-.75-2.47-2.11-6.57,1.43-13.66,7.97-15.83,6.23-2.05,12.87,1.1,15.36,7.06.11.23.23.49.3.76.04.04.08.11.08.19.04.11.19.53.38,1.18l.45,1.59s.04.04,0,.08c2.49,8.5,9.02,34.69,6,62.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m868.81,983.93s0-9.88,12.17-12.86c12.17-2.98,19.51,11.77,19.51,11.77,0,0,11.38-25.88,5.24-46.84-3.08-10.51-12.74-21.24-12.74-21.24l-46.19,10.82s-10.61,42.51,22,58.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m852.84,991.76v8.24h-244.19l-5.02-107.11-2.04-43.95-.49-10.44-1.78-37.58-.08-2.01-.11-1.97-2.27-48.85h242.94c1.96,15.22,3.66,31.2,5.13,47.86.08.65.15,1.33.19,1.97.08.65.11,1.33.15,2.01,1.02,11.5,1.89,23.34,2.64,35.45.11,1.02.15,2.05.23,3.11.04.65.08,1.29.11,1.94.83,13.09,1.51,26.53,2.08,40.19.57,13.28,1.06,26.83,1.43,40.57,0,1.06.04,2.13.08,3.19,0,.61,0,1.21.04,1.82.04,1.78.08,3.57.11,5.35.3,12.6.49,25.35.64,38.26.08,7.29.15,14.57.19,21.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m668.09,938.25l-1.65-7.65,25.93-5.65c10.11-2.2,17.85-10.23,19.74-20.46l5.32-28.89,7.66,1.43-5.32,28.89c-2.46,13.34-12.56,23.81-25.75,26.68l-25.93,5.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 630.31,
    y: 921.7,
    width: 73.91,
    height: 7.79,
    transform: "translate(-298.03 1534.02) rotate(-86.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m674.45,748.09l-10.53,90.41-1.25,10.44-5.1,43.95-12.5,107.11h-233.73c.83-10.06,1.7-19.66,2.53-28.81.68-7.44,1.4-14.57,2.08-21.33.41-3.99.83-7.89,1.21-11.8.3-2.69.6-5.39.87-8.05,1.09-10.06,2.19-19.85,3.29-29.26.41-3.57.83-7.1,1.25-10.55v-.04c.3-2.81.64-5.58.98-8.31,9.85-81.45,19.1-133.76,19.1-133.76h231.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "470.21 845.63 468.4 865.71 468.4 865.75 468.36 866.4 468.36 866.43 465.98 892.89 462.96 926.48 462.96 926.75 462.43 932.55 461.34 944.89 459.68 963.18 456.39 1000 449.71 1000 450.65 989.52 452.96 963.71 454.77 943.6 455.64 933.96 456.24 927.01 459.3 892.89 463.57 845.18 466.02 845.33 466.25 845.37 470.21 845.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "705.79 954.83 657.62 967.59 653.28 1000 646.44 1000 651.46 962.31 661.24 959.73 669.17 957.6 704.09 948.38 705.79 954.83"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m634.28,323.18h5.37c116.3,0,210.72,94.42,210.72,210.72v358.99h-426.8v-358.99c0-116.3,94.42-210.72,210.72-210.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m336.58,715.58h0c-37.09-22.64-48.91-71.22-26.39-108.51l127-210.31c22.52-37.29,70.84-49.17,107.93-26.53h0c37.09,22.64,48.91,71.22,26.39,108.51l-127,210.31c-22.52,37.29-70.84,49.17-107.93,26.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m783.32,444.18c-12.73,28.46-44.95,45.02-77.52,40.03-24.79-3.8-62.81-70.46-110.91-65.24-92.5,10.04-113.19-59.04-90.77-109.16,22.41-50.13,109.37-59.67,194.23-21.33,84.86,38.35,107.39,105.57,84.97,155.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m762.94,413.56c-4.03,5.09-10.39,30.14-13.54,35.84-2.28,4.14-3.58,10.65-7.71,13.33-6.94,4.5-23.56,1.94-31.55,1.08-9.94-1.07-16.82-5.33-21.4-14.48-8.87-17.71-16.4-34.36-32.83-46.54-24.28-17.98-55.94-21.28-85.86-24.98-16.39-2.03-32.9-4.53-48.57-9.95-10.86-3.76-26.9-9.31-31.75-20.87-5.02-11.96-7.95-28.37-9.28-41.14-1.72-16.44.52-33.2,7.28-48.32,28.15-62.97,123.72-81.14,213.45-40.59,13.68,6.18,26.73,13.58,39.14,22.03,8.29,5.64,49.28,43.71,63.59,80.75,12.28,31.8-32.74,83.44-40.97,93.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m709.68,380.37s-2.14-49.49,31.42-71.34c33.56-21.86,22.86,63.94,5.01,87.1-17.85,23.16-31.33,8.38-36.43-15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m708.85,423.79c-.94-2.29-20.83-51.75,7.72-94.09,1.84-2.73,3.72-5.45,5.59-8.16,22.87-33.11,34.35-49.73-5.56-77.6l19.25-27.87c67.62,47.22,35.37,93.91,14.03,124.81-1.8,2.6-3.61,5.22-5.38,7.84-18.2,27-2.83,66.66-2.67,67.06l-32.98,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m724.55,366.31c-15.29,23.78-66.05,18.11-113.37-12.66-47.32-30.76-79.59-74.61-64.3-98.38,15.29-23.78,62.23-32.64,121.21,5.16,47.52,30.45,71.75,82.11,56.46,105.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 473.21,
    y: 838.51,
    width: 214.49,
    height: 10.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m735.73,892.89h-10.38v-379.3c0-136.66-66.81-185.66-67.48-186.14l5.99-8.53c2.93,2.08,71.88,52.66,71.88,194.66v379.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 848.15,
    y: 775.35,
    width: 6.26,
    height: 150.86,
    transform: "translate(-10.33 10.46) rotate(-.7)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m485.35,1000h-31l-3.7-10.48-8.83-24.94-.64-1.86c-2.72-7.63,1.51-15.98,9.25-18.29l1.02-.3c1.09-.3,2.23-.49,3.32-.53,2.3-.15,4.57.34,6.57,1.29,2.3,1.06,4.27,2.73,5.7,4.9.68.95,1.21,2.05,1.62,3.19l16.69,47.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "471.76 1000 361.56 1000 357.29 954.83 356.35 944.55 355.44 934.94 418.03 930.01 456.24 927.01 462.96 926.48 463.23 926.44 464.85 926.33 465.3 931.11 465.64 934.91 465.64 934.94 467.04 949.78 468.25 962.5 471.76 1000"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "471.76 1000 444.16 1000 442.05 977.68 440.84 964.66 441.82 964.59 452.96 963.71 459.68 963.18 468.25 962.5 471.76 1000"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "444.16 1000 416.6 1000 414.71 979.85 442.05 977.68 442.08 977.68 444.16 1000"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "389 1000 386.47 972.9 413.84 970.74 413.88 971.19 414.71 979.85 416.6 1000 389 1000"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "389 1000 361.44 1000 357.18 954.83 357.29 954.83 384.55 952.67 389 1000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m362.8,589.19h0c40.85-3.22,76.82,24.52,80.34,61.96l30.74,261.01c1.8,10.55-5.63,20.44-16.22,21.57l-104.74,11.21c-9.5,1.02-18.2-5.43-20.04-14.86l-37.68-267.27c-3.52-37.44,26.75-70.4,67.61-73.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 688.49,
    cy: 166.46,
    rx: 49.62,
    ry: 49.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 668.09,
    cy: 198.48,
    rx: 73.01,
    ry: 73.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m647.18,276.4l44.83,13.71c33.52,6.88,63.43-22.27,57.64-56.17l-10.81-53.63-101.54-3.45,9.88,99.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m692.45,190.82c-2.39.16-5.91.68-6.72,3.34-.83,2.76,2.68,4.13,4.34,2.48.73-.37,1.59-.55,2.38-.6,3.32-.22,3.34-5.44,0-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m723.72,189.57c-2.39.16-5.91.68-6.72,3.34-.83,2.76,2.68,4.13,4.34,2.48.73-.37,1.59-.55,2.38-.6,3.32-.22,3.34-5.44,0-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m715.26,137.53s-56.47,16.67-53.67,37.85c2.8,21.18-58.71,47.7-58.71,47.7l-18.97-15.39s-8.44-71.39,54.53-87.7c62.97-16.31,84.92,3.48,76.81,17.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "592.65 331.27 701.7 363.48 730.53 218.92 617.39 218.92 592.65 331.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m700.12,379.04l-114.05-39.91c-12.8-4.48-19.56-18.54-15.11-31.41l6.96-20.09c4.45-12.87,18.44-19.67,31.24-15.19l114.05,39.91c12.8,4.48,19.56,18.54,15.11,31.41l-6.96,20.09c-4.45,12.87-18.44,19.67-31.24,15.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m679.31,246.97l6.69,26.49,66.23-2.69-8.43-33.18c-1.56-6.13-7.26-10.25-13.54-9.78l-39.32,2.94c-8.05.6-13.61,8.36-11.62,16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m614.34,195.67s11.91,77.79,13.45,82.59c1.54,4.81,75.43,47.71,108.59,26.47,33.16-21.25,11.72-78.48,11.72-78.48,0,0,8.18,35.74-31.23,34.96-39.41-.78-76.44-18.4-93.46-73.17l-9.07,7.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 605.93,
    cy: 227,
    rx: 20.44,
    ry: 28.45,
    transform: "translate(-29.57 348.72) rotate(-31.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m610.69,227.55c-5.04-11.16-15.36-12.66-15.8-12.72l.5-3.97c.53.07,12.93,1.78,18.92,15.04l-3.62,1.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m714.35,251.46c-1.93,0-4.12-.09-6.33-.36-6.71-.81-13.14-4.75-13.41-4.92l2.21-3.62c.06.04,5.92,3.62,11.69,4.32,5.97.72,11.98,0,12.04,0l.51,4.22c-.17.02-2.97.36-6.72.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m720.42,231.31l-3.54-2.33c1.36-2.09,2.56-4.55,2.9-5.84-1.24-.04-3.73.33-5.91.94l-2.27.63-1.92-11.86,4.17-.68,1.18,7.25c2.48-.52,5.77-.9,7.51.14.76.46,1.28,1.16,1.47,1.99.65,2.84-2.29,7.77-3.58,9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m688.49,210.07c0,3.47,1.52,6.28,3.39,6.28s3.39-2.81,3.39-6.28-1.52-6.28-3.39-6.28-3.39,2.81-3.39,6.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 724.46,
    cy: 210.07,
    rx: 3.39,
    ry: 6.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m612.11,257.65c-2.46,0-4.38-.31-4.51-.34l.69-4.19s4.68.75,8.22-.23l1.13,4.1c-1.83.51-3.81.66-5.52.66Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m649.17,798.93h-148.44c-6.88,0-12.2-5.1-11.87-11.39l5.98-115.69c.32-6.29,6.17-11.39,13.05-11.39h148.44c6.88,0,12.2,5.1,11.87,11.39l-5.98,115.69c-.32,6.29-6.17,11.39-13.05,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m651.32,737.68h-153.11l.21-4h153.11c6.22,0,11.53-4.63,11.82-10.32l1.63-31.62h4.37l-1.63,31.62c-.41,7.89-7.76,14.32-16.4,14.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m648.05,800.93h-140.76l.21-3.99h140.76c6.22,0,11.53-4.63,11.82-10.32l1.07-20.78h4.37l-1.07,20.78c-.41,7.89-7.76,14.32-16.4,14.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m807.21,797.93h57.58c6.88,0,12-5.1,11.44-11.39l-10.36-115.69c-.56-6.29-6.6-11.39-13.48-11.39h-57.58c-6.88,0-12,5.1-11.44,11.39l10.36,115.69c.56,6.29,6.6,11.39,13.48,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m802.74,736.68h62.25l-.36-3.99h-62.25c-6.22,0-11.7-4.63-12.21-10.32l-2.83-31.62h-4.37l2.83,31.62c.71,7.89,8.31,14.32,16.94,14.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m853.83,795.94v3.99h-45.43c-8.64,0-16.22-6.42-16.95-14.33l-1.84-20.77h4.36l1.87,20.77c.49,5.69,5.97,10.33,12.2,10.33h45.79Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "455.3 746.04 410.73 693.08 418.66 686.34 463.23 739.3 455.3 746.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "483.39 625.33 465.43 583.49 474.96 579.35 492.92 621.2 483.39 625.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "465.54 652.02 428.26 576.66 437.56 572.01 474.84 647.38 465.54 652.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m464.87,935.58l-4.91-6.08c8.54-6.97,12.97-17.7,11.86-28.7l-22.89-226.76,93.23-137.23,6.43,4.41-91.63,134.87,22.6,223.91c1.38,13.63-4.12,26.93-14.7,35.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 774.1,
    y: 838.51,
    width: 74.15,
    height: 10.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m353.43,624.82l-53.58-27.54c-7.2-3.7-9.84-11.79-5.91-18.07l72.39-115.47c3.94-6.28,12.97-8.37,20.17-4.67l53.58,27.54c7.2,3.7,9.84,11.79,5.91,18.07l-72.39,115.47c-3.94,6.28-12.97,8.37-20.17,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m390.69,563.15l-58.47-30.05,2.5-3.99,58.47,30.05c6.51,3.35,14.71,1.45,18.27-4.23l19.79-31.56,4.57,2.35-19.79,31.56c-4.94,7.88-16.31,10.51-25.34,5.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m384.89,597.31l-13,20.74c-3.56,5.68-11.76,7.58-18.27,4.23l-33.83-17.38c-1.13,1.19-2.27,2.36-3.42,3.51l34.75,17.86c9.03,4.64,20.4,2.01,25.34-5.87l13-20.74-4.57-2.35Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 328.89,
    y: 892.88,
    width: 123.81,
    height: 10.44,
    transform: "translate(-73.44 35.67) rotate(-4.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m525.04,291.12s119.03,25.44,149.42,56.38c35.59,36.24,38.23,74.72,38.23,74.72,0,0-21.05-22.22-62.48-38.49-37.42-14.69-93.76-19.24-125.17-92.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m524.12,545.08l-10.29-1.36c.04-.34,4.34-34.75-3.23-85.71-7.3-49.14-53.38-75.38-53.84-75.64l5.02-9.14c2.08,1.15,51.01,28.9,59.09,83.23,7.81,52.53,3.45,87.16,3.26,88.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m684.65,430.6c-1.7-4-10.86-70.39-97.04-91.62-51.51-12.69-65.63-36.7-68.4-54.62-4.54-29.31,21.8-58.87,46.89-74.3l11.18,29.85c-17.5,10.76-26.46,27.97-24.72,39.24,1.66,10.74,17.37,20.54,43.09,26.88,109.79,27.05,120.36,112.03,122.13,116.98l-33.12,7.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m550.75,220.09l-3.44-9.47s3.43-3.44,9.9-8.59c0-.06-.01-.11-.02-.17-31.94,9.24-57.15,28.16-69.45,55.68-1.3,2.91-2.38,5.89-3.35,8.9,13.75-23.13,37.42-38.88,66.36-46.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m309.41,621.45l1.97-3.36-5.41-2.87c-2.28,5.02-4.06,10.17-5.24,15.4-4.53,9.85-6.6,20.81-5.53,32.2l.06.42c.77-6.48,2.5-12.71,5.09-18.54,1.75-8,4.73-15.85,9.06-23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m363.11,479.99c3.77-6.2,12.4-8.26,19.29-4.61l9.54,5.06,38.96-66.56c9.23-15.77,22.99-26.91,38.5-32.77,4.58-4.2,9.39-8.13,14.43-11.75-1.08-1.42-2-2.94-2.67-4.6-.43-1.06-.82-2.18-1.22-3.3-.82.71-1.68,1.37-2.49,2.09-16.21,5.93-30.6,17.22-40.24,33.2l-40.73,67.44-9.97-5.12c-7.2-3.7-16.23-1.61-20.17,4.67l-72.39,115.47c-2.73,4.35-2.29,9.57.62,13.59l68.55-112.81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 74.17,
    y: 362.44,
    width: 223.45,
    height: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m280.36,463.05H85.51c-3.27,0-5.92-2.66-5.92-5.95h0c0-3.28,2.65-5.95,5.92-5.95h194.86c3.27,0,5.92,2.66,5.92,5.95h0c0,3.28-2.65,5.95-5.92,5.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 80.59,
    y: 594.65,
    width: 121.66,
    height: 208.28,
    rx: 26.8,
    ry: 26.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m187.69,501.21h-102.18c-3.27,0-5.92-2.66-5.92-5.95h0c0-3.28,2.65-5.95,5.92-5.95h102.18c3.27,0,5.92,2.66,5.92,5.95h0c0,3.28-2.65,5.95-5.92,5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m280.36,284.63H85.51c-3.27,0-5.92-2.66-5.92-5.95h0c0-3.28,2.65-5.95,5.92-5.95h194.86c3.27,0,5.92,2.66,5.92,5.95h0c0,3.28-2.65,5.95-5.92,5.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 79.59,
    y: 310.9,
    width: 114.01,
    height: 11.89,
    rx: 5.95,
    ry: 5.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m184.64,239.37h-94.53c-5.81,0-10.52-4.73-10.52-10.57h0c0-5.84,4.71-10.57,10.52-10.57h94.53c5.81,0,10.52,4.73,10.52,10.57h0c0,5.84-4.71,10.57-10.52,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m155.47,417.12h-65.36c-5.81,0-10.52-4.73-10.52-10.57h0c0-5.84,4.71-10.57,10.52-10.57h65.36c5.81,0,10.52,4.73,10.52,10.57h0c0,5.84-4.71,10.57-10.52,10.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1038.68,
    y: 382.61,
    width: 164.85,
    height: 2.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1182.73,503.94h-130.37c-3.94,0-7.13-3.21-7.13-7.17h0c0-3.96,3.19-7.17,7.13-7.17h130.37c3.94,0,7.13,3.21,7.13,7.17h0c0,3.96-3.19,7.17-7.13,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1149.43,549.96h-97.07c-3.94,0-7.13-3.21-7.13-7.17h0c0-3.96,3.19-7.17,7.13-7.17h97.07c3.94,0,7.13,3.21,7.13,7.17h0c0,3.96-3.19,7.17-7.13,7.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1050.14,
    y: 601.14,
    width: 100.41,
    height: 236.3,
    rx: 35.72,
    ry: 35.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1182.73,288.78h-130.37c-3.94,0-7.13-3.21-7.13-7.17h0c0-3.96,3.19-7.17,7.13-7.17h130.37c3.94,0,7.13,3.21,7.13,7.17h0c0,3.96-3.19,7.17-7.13,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1149.43,334.8h-97.07c-3.94,0-7.13-3.21-7.13-7.17h0c0-3.96,3.19-7.17,7.13-7.17h97.07c3.94,0,7.13,3.21,7.13,7.17h0c0,3.96-3.19,7.17-7.13,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m1145.75,234.19h-87.85c-7,0-12.68-5.71-12.68-12.75h0c0-7.04,5.68-12.75,12.68-12.75h87.85c7,0,12.68,5.71,12.68,12.75h0c0,7.04-5.68,12.75-12.68,12.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1045.22,
    y: 423.06,
    width: 78.04,
    height: 25.5,
    rx: 12.75,
    ry: 12.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m573.74,198.66l195.75-22.04c4.26-.48,7.32-4.34,6.84-8.61h0c-.48-4.28-4.31-7.36-8.57-6.88l-195.75,22.04c-4.26.48-7.32,4.34-6.84,8.61h0c.48,4.28,4.31,7.36,8.57,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m647.32,62.74h0c47.01-5.29,89.38,28.73,94.65,75.99l2.78,24.98-170.24,19.16-2.78-24.98c-5.26-47.26,28.58-89.87,75.59-95.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m697.96,171.72l-19.53,2.2-6.86-61.6c-2.1-18.84-18.99-32.41-37.73-30.3l-9.52,1.07-1.12-10.07c-.59-5.29,3.2-10.05,8.45-10.64h0c29.53-3.32,56.15,18.05,59.45,47.73l6.86,61.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m722.37,168.97l-19.53,2.2-6.86-61.61c-2.1-18.84-18.99-32.4-37.73-30.29l-9.52,1.07-1.12-10.07c-.59-5.29,3.2-10.05,8.45-10.64h0c29.53-3.32,56.15,18.05,59.45,47.73l6.86,61.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m671.35,174.72l-19.53,2.2-6.86-61.61c-2.1-18.84-18.99-32.4-37.73-30.29l-9.52,1.07-1.12-10.07c-.59-5.29,3.2-10.05,8.45-10.64h0c29.53-3.32,56.14,18.05,59.45,47.73l6.86,61.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m550.75,220.09l-3.44-9.47s3.43-3.44,9.9-8.59c0-.06-.01-.11-.02-.17-31.94,9.24-57.15,28.16-69.45,55.68-1.3,2.91-2.38,5.89-3.35,8.9,13.75-23.13,37.42-38.88,66.36-46.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m309.41,621.45l1.97-3.36-5.41-2.87c-2.28,5.02-4.06,10.17-5.24,15.4-4.53,9.85-6.6,20.81-5.53,32.2l.06.42c.77-6.48,2.5-12.71,5.09-18.54,1.75-8,4.73-15.85,9.06-23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m728.48,195.95l2,6.76-3.17,3.95-5.32,6.57.34,1.67.79,4.02.27,1.44.6,3.11.94,4.74.23,1.18.34,1.67,1.28,6.6.68,3.45.72,3.64c4.15,3.64,7.74,7.33,10.8,10.93,2.42,2.81,4.49,5.58,6.27,8.35,1.51,2.28,2.79,4.56,3.93,6.83,1.66,3.23,2.91,6.45,3.85,9.64,1.44,4.59,2.19,9.11,2.42,13.55,4.38,5.47,8.65,11.35,12.54,17.42,5.59,8.54,10.42,17.5,13.74,26.38,1.78,4.74,2.3,9.91,1.89,15.33-.26,3.34-.91,6.83-1.81,10.32-1.55,5.96-3.93,12.03-6.76,17.99,2.45,2.28,4.79,4.59,7.1,7.02,3.17,3.3,6.19,6.76,9.02,10.36,21.86,27.4,35,62.55,35,100.89v173.38h1.93c4.27,0,8.19,2.13,10.61,5.31,1.28,1.71,2.11,3.76,2.3,5.92l.11,1.14,4.08,47.14.34,3.99,3.36,38.68,1.47,17.12.3,3.49.19,1.97.04.65c.04.46.04.95,0,1.37,0,1.03-.19,1.97-.53,2.88-.57,1.59-1.51,3-2.76,4.1-.19.19-.38.34-.57.49l.6,2.2,2.72,9.87,3.85,14.01,21.07,76.59c.83,3.04.72,6.11-.19,8.88-.75,2.35-2.04,4.44-3.78,6.11-.79.84-1.7,1.52-2.68,2.13.49.65,1.1,1.4,1.74,2.28,2.11,2.92,4.79,7.02,6.76,11.42.6,1.25,1.13,2.54,1.55,3.83.04.08.08.11.11.19.19.68,2.95,9.53,4.98,22.51.19,1.06.34,2.13.49,3.23,1.25,8.58,2.08,18.71,1.66,29.34h26.28c3.02-27.63-3.51-53.82-6-62.32.04-.04.04-.08,0-.08-.15-.53-.3-1.06-.45-1.59-.19-.65-.34-1.06-.38-1.18,0-.08-.04-.15-.08-.19-.08-.27-.19-.53-.3-.76-.19-.61-.41-1.21-.68-1.78-.04-.08-.04-.11-.08-.15-.38-.91-.79-1.78-1.25-2.66s-.91-1.75-1.4-2.54c-.94-1.67-1.96-3.26-2.94-4.67-.27-.38-.49-.72-.72-1.06-.49-.65-.94-1.29-1.4-1.9-.64-.87-1.25-1.63-1.78-2.28.57-.34,1.13-.72,1.66-1.14.53-.42,1.02-.83,1.51-1.33.83-.84,1.59-1.82,2.23-2.85.04-.11.11-.19.19-.3,1.93-3.42,2.57-7.63,1.4-11.69l-29.52-104v-.04c1.25-.99,2.27-2.16,2.98-3.53.49-.99.83-2.05.98-3.15.11-.72.15-1.48.08-2.28l-10.38-115.69c-.57-6.3-6.61-11.39-13.48-11.39h-2.04v-175.7c0-2.77-.08-5.54-.19-8.27-.49-9.03-1.66-17.88-3.55-26.46-.3-1.37-.64-2.73-.98-4.1-.34-1.4-.68-2.77-1.06-4.14-.38-1.37-.79-2.73-1.21-4.1-.41-1.33-.83-2.69-1.28-4.02-.45-1.33-.91-2.69-1.4-3.99,0-.08-.04-.11-.04-.15-.91-2.47-1.85-4.9-2.83-7.29-.08-.15-.15-.27-.19-.42-.57-1.29-1.13-2.54-1.7-3.83-1.17-2.5-2.38-5.01-3.66-7.51-.64-1.21-1.28-2.43-1.96-3.64-.68-1.21-1.36-2.43-2.08-3.64-4.19-7.14-8.95-13.97-14.2-20.34-5.21-6.38-10.95-12.37-17.06-17.92h-.04c.68-1.37,1.32-2.69,1.92-4.06.3-.68.6-1.37.91-2.05,1.06-2.54,2.04-5.09,2.91-7.59.26-.87.53-1.75.79-2.62.15-.46.26-.87.41-1.33.19-.65.34-1.33.49-1.97.08-.27.11-.49.19-.72.23-.91.41-1.82.57-2.73.38-2.13.68-4.21.79-6.22.08-.95.11-1.9.11-2.85,0-1.06-.04-2.13-.11-3.15-.19-2.05-.53-4.06-1.06-6.04-.26-.99-.6-1.94-.94-2.88-.38-.95-.75-1.94-1.17-2.88-.42-.99-.83-1.94-1.28-2.88-.41-.99-.9-1.94-1.36-2.88-.49-.99-.98-1.94-1.47-2.88-.98-1.94-2.04-3.83-3.13-5.73-.57-.99-1.13-1.94-1.7-2.85-.34-.61-.72-1.18-1.06-1.75-1.51-2.39-3.06-4.78-4.68-7.1-1.13-1.67-2.34-3.34-3.55-5.01-1.59-2.16-3.17-4.29-4.83-6.38-1.06-1.37-2.15-2.69-3.21-4.02v-.15c-.11-1.94-.34-3.91-.68-5.88-.15-.99-.34-2.01-.57-3.04-.45-2.01-1.02-4.06-1.74-6.11-.72-2.05-1.55-4.14-2.53-6.22-.49-1.03-1.02-2.05-1.59-3.11-.53-1.03-1.13-2.01-1.74-3.04-.04-.04-.04-.08-.08-.11-.6-.95-1.25-1.94-1.89-2.92-.23-.3-.41-.61-.6-.87-2.08-2.92-4.45-5.88-7.17-8.88-2.91-3.19-6.23-6.38-9.97-9.6v-.04l-1.89-9.34-4.53-22.58-2.66-13.14,30.64-3.68s6.85-.95,6.84-8.61-8.73-7.03-8.57-6.88-23.01,2.59-23.01,2.59l-2.78-24.98s-2.99-42.9-44.01-65.97c0,0-17.6-16.32-41.9-13.13,0,0-4.02.59-5.77,2.82l-3.38.39s-7.92-1.84-15.27-.46c0,0-3.88-.07-7.02,4.4,0,0,61.22,8.22,76.61,36.08,0,0,19.13,32.74,22.86,78.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m363.11,479.99c3.77-6.2,12.4-8.26,19.29-4.61l9.54,5.06,38.96-66.56c9.23-15.77,22.99-26.91,38.5-32.77,4.58-4.2,9.39-8.13,14.43-11.75-1.08-1.42-2-2.94-2.67-4.6-.43-1.06-.82-2.18-1.22-3.3-.82.71-1.68,1.37-2.49,2.09-16.21,5.93-30.6,17.22-40.24,33.2l-40.73,67.44-9.97-5.12c-7.2-3.7-16.23-1.61-20.17,4.67l-72.39,115.47c-2.73,4.35-2.29,9.57.62,13.59l68.55-112.81Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img_3.de0816cc7422b0ca473986318233cea1.svg";
export { ForwardRef as ReactComponent };